// extracted by mini-css-extract-plugin
export var projectData = "SlideshowCard-module--projectData--1KFnN";
export var slideshowimage = "SlideshowCard-module--slideshowimage--5AoJW";
export var projectTitle = "SlideshowCard-module--projectTitle--losT2";
export var projectCategory = "SlideshowCard-module--projectCategory--UeApm";
export var projectSummary = "SlideshowCard-module--projectSummary--OZh2B";
export var projectSummaryContainer = "SlideshowCard-module--projectSummaryContainer--sbe72";